import { render, staticRenderFns } from "./supports.vue?vue&type=template&id=209a7fd4"
import script from "./supports.ts?vue&type=script&lang=js&external"
export * from "./supports.ts?vue&type=script&lang=js&external"
import style0 from "./supports.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports